module.exports = {"id":"153296","name":"Yoann Gourcuff","rating":"77","photo":"./data/images/photos/4/153296.png","club":{"name":"Stade Rennais","logo":"./data/images/clubs/StadeRennais.png"},"positions":["MOC","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YoannGourcuff0.json
// module id = 4415
// module chunks = 0